import {useCallback, useEffect, useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";

// Panel indexes remain internal so existing product/profile workflows keep their identity.
export const DISTRIBUTOR_TABS = [
    {name: "overview", label: "Overview", panel: 0},
    {name: "products", label: "Products", panel: 2},
    {name: "analytics", label: "Analytics", panel: 1},
    {name: "coupons", label: "Coupons", panel: 4},
    {name: "company-profile", label: "WorkspaceCompanyProfile", panel: 5},
];

const LEGACY_TABS = {
    "0": "overview", "1": "analytics", "2": "products", "3": "analytics", "4": "coupons", "5": "company-profile",
    ourproducts: "products", "our-products": "products", topproducts: "analytics", "top-products": "analytics",
    mycoupons: "coupons", "my-coupons": "coupons", profile: "company-profile", "profile-settings": "company-profile",
    workspacecompanyprofile: "company-profile",
};

export function distributorTab(value) {
    const normalized = (value || "").toLowerCase();
    return DISTRIBUTOR_TABS.find(tab => tab.name === (LEGACY_TABS[normalized] || normalized)) || DISTRIBUTOR_TABS[0];
}

function useCanonicalTab(location, navigate, name) {
    // Replace aliases/invalid values rather than adding a synthetic entry to browser history.
    useEffect(() => {
        const query = new URLSearchParams(location.search);
        if (query.getAll("tab").length === 1 && query.get("tab") === name) return;
        query.set("tab", name);
        navigate({...location, search: `?${query}`}, {replace: true, state: location.state});
    }, [location, navigate, name]);
}

export default function useDistributorNavigation(tenantId) {
    const location = useLocation();
    const navigate = useNavigate();
    const sequence = useRef(0);
    const params = new URLSearchParams(location.search);
    const selected = distributorTab(params.get("tab"));
    const request = location.state?.distributorWorkflow;
    const workflowRequest = request?.tenantId === tenantId &&
        ((selected.name === "products" && request.type === "upload") ||
            (selected.name === "coupons" && request.type === "coupon")) ? request : null;

    useCanonicalTab(location, navigate, selected.name);

    const selectTab = (name, action = null) => {
        if (selected.name === name && !action) return;
        const query = new URLSearchParams(location.search);
        query.set("tab", name);
        navigate({...location, search: `?${query}`}, {state: {...location.state,
            distributorWorkflow: action ? {type: action, tenantId, id: ++sequence.current} : null}});
    };
    // Consume the history-state request after the real dialog opens; Back/Forward must not replay it.
    const workflowOpened = useCallback(() => {
        const {distributorWorkflow, ...state} = location.state || {};
        if (distributorWorkflow) navigate(location, {replace: true, state});
    }, [location, navigate]);

    return {selected, selectTab, workflowRequest, workflowOpened};
}
